/**
 * mock-members.ts — Shared mock member data for dev/demo mode.
 *
 * Exported by both Members.tsx (list page) and GlobalSearchBar.tsx (global search).
 * In production, both components fetch from /api/members; this module provides
 * the fallback when the API is unavailable (local dev, demo kiosk).
 */

// ---- Supporting types ----

export type PropensityTier = 'high' | 'medium' | 'low' | 'none';
export type LifecycleStage = 'new' | 'active' | 'at_risk' | 'dormant' | 'churned';

// ---- Member list item type ----

export interface MemberListItem {
  memberId: string;
  memberNumber: string;
  displayName: string;
  email: string;
  phone: string;
  lifecycleStage: LifecycleStage;
  propensityTier: PropensityTier;
  topProduct: string | null;
  totalBalance: number;
  memberSince: string;
  lastActivity: string;
  dqDays: number;
  openBsaAlerts: number;
}

// ---- Dev mock data (used when API is unavailable) ----

export const MOCK_MEMBERS: MemberListItem[] = [
  {
    memberId: 'mem-001',
    memberNumber: '100001',
    displayName: 'Sarah J. Mitchell',
    email: 'sarah.mitchell@email.com',
    phone: '(541) 555-0142',
    lifecycleStage: 'active',
    propensityTier: 'high',
    topProduct: 'Mortgage',
    totalBalance: 84320.50,
    memberSince: '2018-03-15',
    lastActivity: '2026-03-13',
    dqDays: 0,
    openBsaAlerts: 0,
  },
  {
    memberId: 'mem-002',
    memberNumber: '100002',
    displayName: 'Marcus T. Rivera',
    email: 'mrivera@email.com',
    phone: '(541) 555-0287',
    lifecycleStage: 'at_risk',
    propensityTier: 'medium',
    topProduct: 'Auto Loan',
    totalBalance: 22150.00,
    memberSince: '2020-07-08',
    lastActivity: '2026-01-22',
    dqDays: 15,
    openBsaAlerts: 0,
  },
  {
    memberId: 'mem-003',
    memberNumber: '100003',
    displayName: 'Priya K. Nair',
    email: 'pnair@email.com',
    phone: '(541) 555-0391',
    lifecycleStage: 'new',
    propensityTier: 'high',
    topProduct: 'CD',
    totalBalance: 51800.00,
    memberSince: '2026-01-04',
    lastActivity: '2026-03-10',
    dqDays: 0,
    openBsaAlerts: 0,
  },
  {
    memberId: 'mem-004',
    memberNumber: '100004',
    displayName: 'Derek O. Fontaine',
    email: 'd.fontaine@email.com',
    phone: '(541) 555-0418',
    lifecycleStage: 'active',
    propensityTier: 'low',
    topProduct: 'Personal Loan',
    totalBalance: 8750.25,
    memberSince: '2015-11-20',
    lastActivity: '2026-02-28',
    dqDays: 0,
    openBsaAlerts: 1,
  },
  {
    memberId: 'mem-005',
    memberNumber: '100005',
    displayName: 'Linda R. Okafor',
    email: 'l.okafor@email.com',
    phone: '(541) 555-0563',
    lifecycleStage: 'dormant',
    propensityTier: 'none',
    topProduct: null,
    totalBalance: 312.00,
    memberSince: '2012-06-30',
    lastActivity: '2025-09-05',
    dqDays: 0,
    openBsaAlerts: 0,
  },
  {
    memberId: 'mem-006',
    memberNumber: '100006',
    displayName: 'James W. Tran',
    email: 'jwtr@email.com',
    phone: '(541) 555-0634',
    lifecycleStage: 'active',
    propensityTier: 'high',
    topProduct: 'HELOC',
    totalBalance: 139200.00,
    memberSince: '2019-09-14',
    lastActivity: '2026-03-12',
    dqDays: 0,
    openBsaAlerts: 0,
  },
];
